module.exports = __webpack_public_path__ + "img/P150T_weapon_79.81ae541c.png";